const nonShipmentSurchargeSummaryResponseToNonShipmentSurchargeSummaryObject = (response) => {
    return {
        surchargeType: response.surcharge_type,
        count: response.count,
        totalSurchargeValue: response.total_surcharge_value,
    };
};

export { nonShipmentSurchargeSummaryResponseToNonShipmentSurchargeSummaryObject };
